import {useUnlockChoiceExperimentDecision} from "../../hooks/use_unlock_choice_experiment_decision";

interface IProps {
    onDecide: (isTreatment: boolean) => void;
}

export const RegistrationSignUpExperimentStep = (props: IProps) => {
    const {onDecide} = props;

    useUnlockChoiceExperimentDecision({onDecide: ({isTreatment}) => onDecide(isTreatment)});

    return null;
};
import {useUnlockChoiceExperimentDecision} from "../../hooks/use_unlock_choice_experiment_decision";

interface IProps {
    onDecide: (isTreatment: boolean) => void;
}

export const RegistrationSignUpExperimentStep = (props: IProps) => {
    const {onDecide} = props;

    useUnlockChoiceExperimentDecision({onDecide: ({isTreatment}) => onDecide(isTreatment)});

    return null;
};
